import React from 'react';
import './streamingOverlay.scss';

const specsTemplate = ({
  fragment,
  buffer,
  bitrate,
  bandwidth,
  resolution,
  currentLevelIndex,
}) => {
  return (
    <div className="streaming-specs__wrapper">
      <div className="streaming-specs__cell streaming-specs__cell-head">
        <h3>{fragment}</h3>
      </div>
      <div className="streaming-specs__cell">
        <strong>{`Buffer: ${buffer}`}</strong>
      </div>
      <div className="streaming-specs__cell">
        <strong>{`Bitrate: ${bitrate}`}</strong>
      </div>
      <div className="streaming-specs__cell">
        <strong>{`Est. Bandwidth: ${bandwidth}`}</strong>
      </div>
      <div className="streaming-specs__cell">
        <strong>{`Resolution: ${resolution}`}</strong>
      </div>
      <div className="streaming-specs__cell">
        <strong>{`Current Level: ${currentLevelIndex}`}</strong>
      </div>
    </div>
  );
};

const buildFragmentSpecs = (fragments, specs) => {
  return fragments.map((fragment, index) => {
    const { buffer, bitrate, bandwidth, resolution, currentLevelIndex } = specs[
      fragment
    ];
    return (
      <React.Fragment key={`${buffer}_${index}`}>
        {specsTemplate({
          fragment: `Fragment #${fragment}`,
          buffer,
          bitrate,
          bandwidth,
          resolution,
          currentLevelIndex,
        })}
      </React.Fragment>
    );
  });
};

const StreamingOverlay = React.memo(props => {
  const { specs, currentFragmentIndex } = props;
  const fragments = Object.keys(specs);
  if (!fragments.length) return null;
  return (
    <div className="streaming-specs">
      <div className="streaming-specs__current-fragment">
        {specsTemplate({
          fragment: `Current fragment #${currentFragmentIndex}`,
          ...specs[currentFragmentIndex],
        })}
      </div>
      <div className="streaming-specs__all-fragments">
        {buildFragmentSpecs(fragments, specs)}
      </div>
    </div>
  );
});

export default StreamingOverlay;
